import { isProviderApp, isAdminApp } from "../config/theme";
import { identifyUser, resetUser, setUserProperties } from "./amplitude";
import { identifyClarityUser, setClarityTag } from "./clarity";

/**
 * Identify a user across all analytics providers after login/signup.
 * @param {object} user - User object from auth state
 */
export function identifyAnalyticsUser(user) {
  if (!user) return;

  const appType = isAdminApp()
    ? "admin"
    : isProviderApp()
      ? "provider"
      : "homeowner";

  const userProperties = {
    user_type: user.role === "service_provider" ? "provider" : user.role,
    app_type: appType,
    email_verified: Boolean(user.isEmailVerified),
    phone_verified: Boolean(user.isPhoneVerified),
    has_password: Boolean(user.hasPassword),
    signup_method: user.linkedOAuthProviders?.length > 0 ? "oauth" : "email",
  };

  // Provider-specific properties
  if (user.role === "service_provider" && user.businessName) {
    userProperties.has_business_name = true;
  }

  identifyUser(user.id, userProperties);
  identifyClarityUser(user.id);
  setClarityTag("user_type", userProperties.user_type);
}

/**
 * Reset user identity on logout.
 */
export function resetAnalyticsUser() {
  resetUser();
}

/**
 * Update specific user properties (e.g., after verification).
 * @param {object} properties - Key-value pairs to set
 */
export function updateAnalyticsUserProperties(properties) {
  setUserProperties(properties);
}
